import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { X } from 'lucide-react';
export function DietProblem() {
  return <section className="py-20 px-4 bg-white" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-14">
          <FadeIn data-id="element-15">
            <h2 className="text-3xl md:text-4xl font-serif text-brown mb-8" data-id="element-16">
              El problema de “las dietas”
            </h2>
            <p className="text-lg text-brown-light mb-6" data-id="element-17">
              Las dietas suelen fallar por 3 motivos:
            </p>
            <ul className="space-y-4" data-id="element-18">
              {['te piden perfección,', 'te dejan sin sistema,', 'te hacen sentir culpable cuando sos humana.'].map((item, i) => <li key={i} className="flex items-center gap-3 text-lg text-brown-light" data-id="element-19">
                  <X className="w-5 h-5 text-rose flex-shrink-0" data-id="element-20" />
                  <span data-id="element-21">
                    {i + 1}) {item}
                  </span>
                </li>)}
            </ul>
          </FadeIn>

          <FadeIn delay={0.2} className="bg-sage/10 p-8 md:p-10 rounded-2xl md:rotate-2 border border-sage/20" data-id="element-22">
            <p className="text-xl font-serif text-brown mb-4" data-id="element-23">Acá no.</p>
            <p className="text-2xl md:text-3xl font-serif text-sage font-medium leading-tight" data-id="element-24">
              Acá volvés en la próxima comida.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}